import React, { FunctionComponent } from 'react'
import { DispensingBlock } from './DispensingBlock'
import { DurationBlock } from './DurationBlock'
import { DosageBlock } from './DosageBlock'
import { PosologyDetailProps } from './PosologyDetail.model'
import { PosologyFormResource } from '../../../../model/Posology'
import styles from './PosologyDetail.module.scss'

export const PosologyDetail: FunctionComponent<PosologyDetailProps> = ({
  drugs,
  posologyForm,
  disabled,
  availableAdministrationRoutes,
  setPosologyForm,
}) => {
  const handleFormChange = (form: Partial<PosologyFormResource>) => {
    setPosologyForm({
      ...posologyForm,
      ...form,
    })
  }

  return (
    <div className={styles.posologyDetailContainer}>
      <div className={styles.posologyDetailContent}>
        <div className={styles.posologyDetailHalfPart}>
          <DispensingBlock
            drugs={drugs}
            posologyForm={posologyForm}
            setPosologyForm={handleFormChange}
            disabled={disabled}
            availableAdministrationRoutes={availableAdministrationRoutes}
          />
          <DurationBlock
            posologyForm={posologyForm}
            setPosologyForm={handleFormChange}
            disabled={disabled}
          />
        </div>
        <div className={styles.posologyDetailHalfPart}>
          <DosageBlock
            drugs={drugs}
            posologyForm={posologyForm}
            setPosologyForm={handleFormChange}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  )
}
